import React from 'react';
import { buttonRootStyle } from 'components/Buttons/Button';
import tw from 'twin.macro';

interface Props {
  onClick: () => void;
  children: any;
  cursor?: 'pointer' | 'text';
  className?: string;
}

export function ROSelect(props: Props) {
  const { children, onClick, cursor = 'pointer', className } = props;
  return (
    <div
      css={[
        buttonRootStyle({ minimal: false, fill: true }),
        tw`justify-start hover:bg-transparent border-opacity-0 hover:border-opacity-100 border-neutral-quiet text-sm md:px-1 py-0! md:py-1.5! bg-transparent min-h-0 md:min-h-[2.125rem]`,
        cursor === 'pointer' && tw`cursor-pointer`,
        cursor === 'text' && tw`cursor-text`,
        className,
      ]}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
